import _ from "lodash";

const appContainsFamilyAndManufacturer = (app, family = null, manufacturer = null) => {
  return app.family.indexOf(family) > -1 && app.manufacturer.indexOf(manufacturer) > -1;
};

export const mapApplicationsMachines = (machineApps, allApps) => {
  const { family, manufacturer, applications } = machineApps;

  const statusEmpty = {
    enabled: false,
    expireDate: null
  };

  // Recupero tutte le applicazioni disponibili per la macchina
  const allAppsMachineAvailable = (allApps || []).filter(app =>
    appContainsFamilyAndManufacturer(app, family, manufacturer)
  );
  //console.log("MACHINE MAP apps available", machineApps, allAppsMachineAvailable);

  // Aggiorno lo stato delle applicazioni disponibili per la macchina
  const _applications = (allAppsMachineAvailable || []).map(app => {
    const findAppMachineStatus =
      applications.find(item => item.application.id === app.id) || statusEmpty;
    const status = (({ enabled, expireDate }) => ({ enabled, expireDate }))(findAppMachineStatus);
    const appId = app.appId;
    return {
      ...app,
      appId,
      ico: `ico_${appId}.png`,
      ...status
    };
  });

  return _.sortBy(_applications, item => item.enabled).reverse();
};
